import { Component, OnInit, Input, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { NoticeService } from 'app/services/notice/notice.service';


@Component({
  selector: 'ota-dialog-notify-budget',
  templateUrl: './dialog-notify-budget.component.html',
  styleUrls: ['./dialog-notify-budget.component.scss']
})
export class DialogNotifyBudgetComponent implements OnInit {
  @Input('text') text: string;
  private agree: number;

  constructor( @Inject(MD_DIALOG_DATA) public data: any,
    public dialogRef: MdDialogRef<DialogNotifyBudgetComponent>,
    private noticeService: NoticeService) { }


  ngOnInit() {
  }

  handleBtnOk() {
    if (this.agree) {
      this.noticeService.setNotifyDisabled('BOOK_NOTIFY_BUDGET', true);
    }

    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-notify-budget/dialog-notify-budget.component.ts